var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 13
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.48 6.495a.38.38 0 0 1-.111.269l-5.32 5.32a.38.38 0 0 1-.538-.537l4.672-4.672H1.14a.38.38 0 0 1 0-.76h15.043L11.51 1.444a.38.38 0 0 1 .538-.537l5.32 5.32a.38.38 0 0 1 .111.268z"
})));
export default SvgArrowRight;